<div class="wrapper">
  <div class="block-center mt-4 wd-xl">

    <div class="card card-flat">

      <div class="card-header text-center cor-principal-background">
        <a href="#">
          <img class="block-center rounded img-logo" src="assets/img/aceleramovel_icon.png" alt="Acelera Movel" />
        </a>
      </div>

      @if (operacao === 'auto') {
        <div class="card-body">
          <img class="loading-auto" src="assets/img/loader.svg" alt="carregando">
        </div>
      }

      @if (operacao === 'setup') {
        <div class="card-body">
          <img class="loading-auto" src="assets/img/loader.svg" alt="carregando">
        <!--p class="text-primary">Carregando filtros...</p-->
        <p class="text-danger">{{errorFiltro}}</p>
        @if (errorFiltro != '') {
          <button class="btn btn-block btn-danger mt-3"
          (click)="carregaFiltros()">RECARREGAR FILTROS</button>
        }
        <button class="btn btn-block btn-light mt-3"
        (click)="voltarLogin()">VOLTAR AO LOGIN</button>
      </div>
    }

    @if (operacao === 'manual') {
      <div class="card-body">
        <p class="text-center py-2">Faça o login para continuar</p>
        <form [formGroup]="valForm" class="form-validate mb-3" role="form" name="loginForm" novalidate="" (submit)="submitForm($event, valForm.value)">
          <div class="form-group">
            <div class="input-group with-focus">
              <input class="form-control border-right-0" id="exampleInputEmail1" type="text" name="cpf" placeholder="CPF" autocomplete="off" formControlName="cpf" required="" />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-user"></em>
                </span>
              </div>
            </div>
            @if (valForm.controls['cpf'].hasError('required') && (valForm.controls['cpf'].dirty || valForm.controls['cpf'].touched)) {
              <div class="text-danger">Este campo é obrigatório</div>
            }
          </div>
          <div class="form-group">
            <div class="input-group with-focus">
              <input class="form-control border-right-0" id="exampleInputPassword1" type="password" name="password" placeholder="Password" formControlName="password" required="" />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-lock"></em>
                </span>
              </div>
            </div>
            @if (valForm.controls['password'].hasError('required') && (valForm.controls['password'].dirty || valForm.controls['password'].touched)) {
              <div class="text-danger">Este campo é obrigatório</div>
            }
          </div>
          <div class="clearfix">
            <div class="checkbox c-checkbox float-left mt0">
              <label>
                <input type="checkbox" value="true" name="remember" formControlName="remember" />
                <span class="fa fa-check"></span>lembrar-me</label>
              </div>
              <div class="float-right">
                <a class="text-muted" [routerLink]="'/recuperar-senha'">Esqueceu a senha?</a>
              </div>
            </div>
            <button class="btn btn-block cor-principal-background text-white mt-3" type="submit">ENTRAR</button>
            <button class="btn btn-block btn-light mt-3" (click)="primeiroAcesso()">PRIMEIRO ACESSO</button>
          </form>
          @if (errorMessage != '') {
            <div class="alert alert-danger text-center">{{errorMessage}}</div>
          }
          <div class="p-3 text-center">
            <span>&copy;</span>
            <span>{{ settings.getAppSetting('year') }}</span>
            <span class="mx-2">-</span>
            <span>{{ settings.getAppSetting('name') }}</span>
          </div>
        </div>
      }
    </div>

  </div>
</div>
